import { QUERY_KEYS } from 'api/query-keys';
import { companyService } from 'ogp/services';
import { useQuery } from 'react-query';
import { useSiteDetection } from 'shared/hooks/use-site-detection';
import { CACHE_TIME_LONG, STALE_TIME_LONG } from 'shared/react-query/query-defaults';

export const useGetCompanyTheme = () => {
  const { isOGP } = useSiteDetection();

  const queryFn = async () => await companyService.getCompanyTheme();

  return useQuery(QUERY_KEYS.ownCompanyTheme(), queryFn, {
    cacheTime: CACHE_TIME_LONG,
    staleTime: STALE_TIME_LONG,
    enabled: isOGP,
  });
};
